var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',_vm._g(_vm._b({attrs:{"size":"small","icon":_vm.icon,"loading":_vm.loading},on:{"click":_vm.read}},'el-button',_vm.$attrs,false),_vm.$listeners),[_vm._t("default",function(){return [_vm._v("身份证读卡")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }